export enum CorrectionsTdcSourceCdEnum {
  bil = 'BIL',
  pur = 'PUR',
  edi = 'EDI',
  web = 'WEB',
  cor = 'COR'
}
